module.exports = __webpack_public_path__ + "img/mycart_02.5992b1a0.png";